import { type ReactNode, useMemo } from "react";

import {
  FeatureFlagsContext,
  type FeatureFlagsContextValue,
} from "./_context/FeatureFlagsContext";
import { useFeatureFlags as useFeatureFlagsQuery } from "./_hooks/useFeatureFlags";

interface Props {
  children: ReactNode;
}

export const FeatureFlagsProvider = ({ children }: Props) => {
  const queryResult = useFeatureFlagsQuery();

  const value = useMemo<FeatureFlagsContextValue>(
    () => ({
      flags: queryResult.flags,
      flagsMap: queryResult.flagsMap,
      isLoading: queryResult.isLoading,
      isReady: queryResult.isReady,
      isError: queryResult.isError,
      error: queryResult.error,
      isEnabled: queryResult.isEnabled,
    }),
    [
      queryResult.flags,
      queryResult.flagsMap,
      queryResult.isLoading,
      queryResult.isReady,
      queryResult.isError,
      queryResult.error,
      queryResult.isEnabled,
    ],
  );

  return <FeatureFlagsContext value={value}>{children}</FeatureFlagsContext>;
};
